import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { storage, STORAGE_KEYS } from '@utils/storage';
import { ssoService } from '@services/ssoService';
import { useAuthStore } from '@store/authStore';

export function SsoCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      navigate('/login?sso_error=missing_code', { replace: true });
      return;
    }

    let cancelled = false;

    const exchange = async () => {
      try {
        const { user, tokens } = await ssoService.exchangeCode(code);
        if (cancelled) return;

        storage.set(STORAGE_KEYS.AUTH_TOKENS, tokens);
        storage.set(STORAGE_KEYS.USER_DATA, user);
        storage.set(STORAGE_KEYS.SELECTED_ROLE, user.role);

        useAuthStore.setState({
          user,
          tokens,
          selectedRole: user.role,
          isAuthenticated: true,
          isLoading: false,
          error: null,
        });

        window.dispatchEvent(new CustomEvent('auth:tokens', { detail: { tokens } }));
        navigate('/restaurant', { replace: true });
      } catch {
        if (cancelled) return;
        setError('Lezzet Yolda üzerinden giriş tamamlanamadı.');
        setTimeout(() => {
          navigate('/login?sso_error=exchange_failed', { replace: true });
        }, 2500);
      }
    };

    void exchange();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      {error ? (
        <>
          <p className="text-lg font-semibold text-red-600">{error}</p>
          <p className="mt-2 text-sm text-slate-500">Giriş sayfasına yönlendiriliyorsunuz…</p>
        </>
      ) : (
        <>
          <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
          <p className="text-lg font-semibold text-slate-800">Lezzet Yolda Toptan&apos;a bağlanılıyor…</p>
          <p className="mt-2 text-sm text-slate-500">Lütfen bekleyin.</p>
        </>
      )}
    </div>
  );
}
